<template lang="pug">
  div
    div.row
      div.col-10
        div.form-inline
          h4 <kbd>區間測速資訊</kbd>
          p &nbsp &nbsp 
          div(v-for="item in paras")
            h4 <kbd class="navbar-brand-kbd">固定桿代碼{{item.fixed_link_code}}  道路限速{{item.road_speed_limit}} 舉發車速(超速){{item.break_value}} 舉發車速(龜速){{item.break_value_slow}}</kbd>
        div
          vuetable(
            ref="vuetable"
            :api-url="`${server}/api/interval-speed-data/`"
            data-path="results"
            pagination-path=""
            :per-page=20
            :row-class="onRowClass"
            :fields="fields"
            :css="boostrapCss"
            :http-options="httpOptions"
            :append-params="moreParams"
            detail-row-component="check-detail"
            @vuetable:loading="onLoading"
            @vuetable:loaded="onLoaded"
            @vuetable:pagination-data="onPaginationData"
            @vuetable:cell-clicked="onCellClicked")
              //-20220307 add
              <template slot-scope="props" slot="index">
                span {{(props.rowIndex+1)+(currentPage-1)*20}}
              </template>
          vuetable-pagination(
            ref="pagination"
            @vuetable-pagination:change-page="onChangePage"
            :css="boostrapCss.pagination" 
          )
        div(v-if="tableDataLen==0 && loadingData==false")
          h1.text-center.display-4 今日無違規資料
      div.col-2
        h3.text-info <strong>請輸入查詢區間</strong>    
        div.form-group
          div.form-group
            label 開始時間
            input.form-control.form-control-sm(type="date" v-model="startDate")
          div.form-group
            label 結束時間
            input.form-control.form-control-sm(type="date" v-model="endDate")
          div.form-group
            label 過濾條件
            input.form-control.form-control-sm(type="text" v-model="queryString" placeholder="輸入車號或開單狀態")
          button.btn.btn-primary.mb-2.w-100(@click="onFilterSet" type="submit") 篩選
            //span (開單狀態: t0:尚未處理, t1:已開單, t3:無法開單)
          div.form-group
            label 警示車速(km/hr)
            input.form-control.form-control-sm(class="text-danger" type="number" v-model="alarmSpeed" placeholder="輸入警示車速")
            label 警示違規筆數
            input.form-control.form-control-sm(class="text-danger" type="number" v-model="alarmIllegalNum" placeholder="輸入警示違規筆數")
            h3(class="text-danger" style="font-weight: bold;") 違規件數:{{totalIllegalNum}}
          div(v-if="totalIllegalNum>alarmIllegalNum")
            h4(class="text-danger") 違規筆數異常，請注意!!     
        Loader(v-if="loadingData") 
          h4 資料載入中，請稍等
    
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import Vue from 'vue';
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';
import { mapState } from 'vuex';
import Vuetable from 'vuetable-2/src/components/Vuetable';
import readCookie from '@/vuex/functions/readCookie';
import server from '@/config';
import Loader from '../../common/Loader';
import CheckDetail from './CheckDetail';

Vue.component('check-detail', CheckDetail);

export default {
  name: 'CarList',
  data() {
    return {
      //20220307 add
      currentPage: 1,
      //20200807 add
      totalIllegalNum: '',
      alarmIllegalNum: '',
      tableDataLen: undefined,
      tmpId: '',
      startDate: undefined,
      endDate: undefined,
      loadingData: false,
      paras: [],
      boostrapCss: {
        tableClass: 'table table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        },
      },
      httpOptions: {
        headers: {
          Authorization: `Token ${readCookie('Token')}`,
        },
      },
      server,
      fields: [
        //20220307 add
        {
          name: '__slot:index',
          title: '序號',
        },
        /*
        {
          name: 'xactno',
          //sortField: 'xactno',
          title: '流水號',
        },
        */
        {
          name: 'plt_no.plt_no',
          //sortField: 'plt_no.plt_no',
          title: '車牌號碼',
        },
        /*
        {
          name: 'car_tp.car_tp',
          title: '車別代碼',
        },
        */
        {
          name: 'vli_dateTime_in',
          sortField: 'vli_dateTime_in',
          title: '進入時間',
          callback: this.readableDate,
        },
        {
          name: 'vli_dateTime_out',
          sortField: 'vli_dateTime_out',
          title: '離開時間',
          callback: this.readableDate,
        },
        {
          name: 'pass_time',
          title: '通過時間(秒)',
        },
        {
          name: 'speed',
          sortField: 'speed',
          title: '車速',
        },
        {
          name: 'fixed_link_code.fixed_link_code',
          title: '固定桿代碼',
        },
        {
          name: 'rule_code.rule_code',
          title: '條款代碼',
        },
        {
          name: 'status',
          title: '開單狀態',
          //sortField: 'status',
          callback: this.status,
        },
      ],
      queryString: '',
      alarmSpeed: '',
      moreParams: {
        fixed_link_code_id: this.$store.state.user.user.department.fixed_link_code,
        start_date: moment().format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
      },
    };
  },
  components: {
    Vuetable,
    VuetablePagination,
    Loader,
  },
  async mounted() {
    //this.loadingData = true;
    await this.getPara();
    this.alarmSpeed = this.paras[0].alarmSpeed;
    this.alarmIllegalNum = this.paras[0].alarmIllegalNum;
    //this.loadingData = false;
  },
  watch: {
    startDate(val) {
      if (val > this.endDate && this.endDate !== '') {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '開始時間不可晚於結束時間',
        });
        this.startDate = this.endDate;
      }
    },
    endDate(val) {
      if (val < this.startDate && this.startDate !== '') {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '結束時間不可早於開始時間',
        });
        this.endDate = this.startDate;
      }
    },
  },
  methods: {
    onRowClass(data, index) {
      if (parseInt(data.speed,10) >= this.alarmSpeed) {
        return 'over-speed';
      }
      return '';
    },
    onLoading() {
      this.loadingData = true;
      console.log('loading... show your spinner here');
    },
    onLoaded() {
      this.loadingData = false;
      console.log('loaded! .. hide your spinner here');
      this.tableDataLen=this.$refs.vuetable.tableData.length;
      console.log('datalen:',this.tableDataLen);
      if(this.tableDataLen>0) {
        console.log('id:',this.$refs.vuetable.tableData[0].id);
        this.onCellClicked(this.$refs.vuetable.tableData[0]);
      }
      //20200807 add
      this.totalIllegalNum = this.$refs.vuetable.tablePagination.total
      console.log('totalIllegalNum:',this.totalIllegalNum);
    },
    onCellClicked(data, field, event) {
      console.log('cellclicked');
      console.log('tmpId:',this.tmpId);
      console.log('nowId:',data.id);
      console.log('vuetable:',this.$refs.vuetable);
      if(this.tmpId=='')
        this.tmpId=data.id;
      else if(this.tmpId !== '' && this.tmpId != data.id)
      {
        this.$refs.vuetable.toggleDetailRow(this.tmpId);
        this.tmpId=data.id;
      }
      else if(this.tmpId == data.id)
        this.tmpId = '';   
      //this.$refs.vuetable.toggleDetailRow(data.id);
      setTimeout(() => {
          this.$refs.vuetable.toggleDetailRow(data.id);
        }, 50);
    },
    onPaginationData(paginationData) {
      this.currentPage = paginationData.current_page;
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet() {
      if (this.startDate == undefined || this.endDate == undefined) {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '請輸入查詢區間',
        });
        return;
      }
      console.log('start:',this.startDate);
      console.log('end:',this.endDate);
      if(this.queryString=="尚未處理")
          this.queryString="t0"
        else if(this.queryString=="已開單")
          this.queryString="t1"
        else if(this.queryString=="未違規")
          this.queryString="t2"  
        else if(this.queryString=="無法開單")
          this.queryString="t3" 
      this.moreParams = {
        search: this.queryString,
        fixed_link_code_id: this.$store.state.user.user.department.fixed_link_code,
        start_date: this.startDate,
        end_date: this.endDate,
      };
      const vm = this;
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    getSortParam(sortOrder) {
      return sortOrder.map((sort) => {
        return (sort.direction === 'desc' ? '-' : '') + sort.field;
      }).join(',');
    },
    readableDate(value) {
      return moment(value).format('YY/MM/DD HH:mm:ss.SSS'); //0~23hr format
    },
    status(value) {
      if(value=="t0")
        return "尚未處理"
      else if(value=="t1")
        return "已開單"
      else if(value=="t2")
        return "未違規"
      else if(value=="t3")
        return "無法開單"
    },
    getPara() {
      return this.instance.get('/api/fixed-link-code/', {
        params: {
          fixed_link_code_id: this.$store.state.user.user.department.fixed_link_code,
        },
      })
      .then((res) => {
        this.paras = res.data;
      });
    },
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
    user() {
      return this.$store.state.user;
    },
    //tableDataLen() {
    //  return this.$refs.vuetable.tableData.length;
    //},
  },
  // computed: mapState({
  //   system: state => state.system,
  // }),
};
</script>

<style lang="sass">
.user-layout-head
  margin-bottom: 10px

.navbar-brand-kbd
  background-color: #00695C;  // Changes background color
  color: white;                  // Changes text color

th.sortable
  color: #ec971f;

.over-speed
  background-color: #e57373
</style>




// WEBPACK FOOTER //
// CarList.vue?6040f3f4